exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "my-loans-context-menu .my-loans-context-menu{position:absolute;top:26px;right:24px;bottom:0;z-index:1;cursor:pointer;border-radius:1px}my-loans-context-menu .my-loans-context-menu.mobile{top:18px;right:15px}my-loans-context-menu .my-loans-context-menu.mobile .arrow-up{margin:0 0 0 auto;border-right:none}my-loans-context-menu .my-loans-context-menu.mobile .option{text-transform:uppercase}my-loans-context-menu .my-loans-context-menu.mobile .option:last-child{border-bottom:none}my-loans-context-menu .arrow-up{width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-bottom:3px solid #0072c9;margin:0 auto}my-loans-context-menu .remove-events{pointer-events:none}my-loans-context-menu .option{width:156px;height:38px;background:#0072c9;text-align:center;color:#fff;font-size:13px;line-height:35px;border-bottom:1px solid #fff}my-loans-context-menu .option:hover{background:#04408f}my-loans-context-menu .btn-footer{display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/myLoans/myLoansContextMenu/myLoansContextMenu.scss
// module id = 1974
// module chunks = 0